import script from "./PriceshowContactWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./PriceshowContactWidget.vue?vue&type=script&lang=ts&setup=true"

import "./PriceshowContactWidget.vue?vue&type=style&index=0&id=0a9a96da&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\wordpress\\energiehoch3-v2\\wp-content\\themes\\io.shop-energiehoch3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a9a96da"]])

export default __exports__